import * as authHooks from '@repo/cf-user/hooks/auth'

export const getUserAuthFetcher = authHooks.getUserAuthFetcher
export const useIsAuthenticated = authHooks.useIsAuthenticated
export const useIsLoggedInQuery = authHooks.useIsLoggedInQuery
export const useSetUserQuery = authHooks.useSetUserQuery
export const useUserAuthQuery = authHooks.useUserAuthQuery
export const useUserIdQuery = authHooks.useUserIdQuery
export const useUserQuery = authHooks.useUserQuery
export const userAuthQueryFetcher = authHooks.userAuthQueryFetcher
export const userAuthQueryKey = authHooks.userAuthQueryKey
export const userAuthQueryOptions = authHooks.userAuthQueryOptions
export const userQueryFetcher = authHooks.userQueryFetcher
export const userQueryKey = authHooks.userQueryKey
export const userQueryOptions = authHooks.userQueryOptions
export const userQueryRootKey = authHooks.userQueryRootKey
